import { render } from "./PreviewSospensioniRiattivazioni.vue?vue&type=template&id=75e72f0f&scoped=true"
import script from "./PreviewSospensioniRiattivazioni.vue?vue&type=script&lang=js"
export * from "./PreviewSospensioniRiattivazioni.vue?vue&type=script&lang=js"

import "./PreviewSospensioniRiattivazioni.vue?vue&type=style&index=0&id=75e72f0f&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e72f0f"]])

export default __exports__